import { useCallback } from "react";
import { _getStartEndColumns } from "./_getStartEndColumns";
import { _getItemsAfterThisWidgetInThisRow } from "./_getItemsAfterThisWidgetInThisRow";
import { TOTAL_COLUMNS } from "../constants";


export const useRowHover = ({ widgetIdx, startCol, endCol, config }) => {
  const getWidgetsInCurrentRow = useCallback(() => {
    const widgetsInRow = [widgetIdx];
    
    if (startCol === 1) {
      // Current widget is the first in the row, get all widgets after it
      const itemsAfterIndexes = _getItemsAfterThisWidgetInThisRow({
        widgetIndex: widgetIdx,
        endCol: endCol,
        config,
        TOTAL_COLUMNS,
      });
      widgetsInRow.push(...itemsAfterIndexes);
    } else {
      // Current widget is not first, find the first widget in this row
      for (let i = widgetIdx - 1; i >= 0; i--) {
        const [prevStartCol] = _getStartEndColumns(config[i].gridColumn);
        if (prevStartCol === 1) {
          widgetsInRow.unshift(i);
          const itemsAfterIndexes = _getItemsAfterThisWidgetInThisRow({
            widgetIndex: i,
            endCol: _getStartEndColumns(config[i].gridColumn)[1],
            config,
            TOTAL_COLUMNS,
          });
          widgetsInRow.push(...itemsAfterIndexes);
          break;
        }
      }
    }
    
    return widgetsInRow;
  }, [widgetIdx, startCol, endCol, config]);

  // hover class to all widgets in the current row
  const addRowHoverClass = useCallback(() => {
    const widgetsInRow = getWidgetsInCurrentRow();
    
    widgetsInRow.forEach(index => {
      const element = document.querySelector(`[data-widget-index="${index}"]`);
      if (element) {
        element.classList.add('row-hovered');
      }
    });
  }, [getWidgetsInCurrentRow]);

  const removeRowHoverClass = useCallback(() => {
    const widgetsInRow = getWidgetsInCurrentRow();
    
    widgetsInRow.forEach(index => {
      const element = document.querySelector(`[data-widget-index="${index}"]`);
      if (element) {
        element.classList.remove('row-hovered');
      }
    });
  }, [getWidgetsInCurrentRow]);

  // Mouse enter handler for row hover effects
  const handleMouseEnter = useCallback(() => {
    addRowHoverClass();
  }, [addRowHoverClass]);

  // Mouse leave handler for row hover effects
  const handleMouseLeave = useCallback(() => {
    removeRowHoverClass();
  }, [removeRowHoverClass]);

  return {
    handleMouseEnter,
    handleMouseLeave,
  };
};
